export const messages = {
  en: {
    storeOrderManage: {
      title: 'Mall Order Management',
      queryConditions: 'Query Conditions',
      orderInfo: 'Order Information',
      orderId: 'Order ID',
      productName: 'Product Name',
      quantity: 'Quantity',
      platform: 'Platform',
      type: 'Type',
      shop: 'Shop',
      userName: 'User Name',
      orderAmount: 'Goods Amount',
      freight: 'Delivery Fee',
      payAmount: 'Total Payable',
      cashPayment: 'Cash Payment',
      couponDiscount: 'Coupon/Discount',
      goodsDeduction: 'Goods Deduction',
      propertyDeduction: 'Property Deduction',
      deductionTotal: 'Deduction Total',
      userOrderDeduction: 'User Order Deduction',
      orderStatus: 'Order Status',
      createTime: 'Create Time',
      operations: 'Operations',
      query: 'Query',
      reset: 'Reset',
      export: 'Export',
      orderDetail: 'Order Detail',
      selectShop: 'Please select shop',
      selectStatus: 'Please select status',
      selectType: 'Please select type',
      personCommunity: 'User Community',
      selectPersonCommunity: 'Please select user community',
      startTime: 'Create Time Start',
      endTime: 'Create Time End',
      to: 'to',
      exportDateRangeError: 'Export time range cannot exceed 3 months',
      service: 'Service',
      product: 'Product'
    }
  },
  zh: {
    storeOrderManage: {
      title: '商城订单管理',
      queryConditions: '查询条件',
      orderInfo: '订单信息',
      orderId: '订单号',
      productName: '商品名称',
      quantity: '购买数量',
      platform: '平台',
      type: '类型',
      shop: '商家',
      userName: '用户名称',
      orderAmount: '商品金额',
      freight: '配送费',
      payAmount: '应付总额',
      cashPayment: '现金支付',
      couponDiscount: '优惠券满减',
      goodsDeduction: '商城专用抵扣金',
      propertyDeduction: '通用抵扣金',
      deductionTotal: '抵扣金合计',
      userOrderDeduction: '用户本单可得抵扣金',
      orderStatus: '订单状态',
      createTime: '创建时间',
      operations: '操作',
      query: '查询',
      reset: '重置',
      export: '导出',
      orderDetail: '订单详情',
      selectShop: '请选择商家',
      selectStatus: '请选择状态',
      selectType: '请选择类型',
      personCommunity: '用户所属小区',
      selectPersonCommunity: '请选择用户所属小区',
      startTime: '创建时间起',
      endTime: '创建时间止',
      to: '至',
      exportDateRangeError: '导出时间范围不能超过 3 个月',
      service: '服务',
      product: '商品'
    }
  }
}
